import { useTranslation } from 'next-i18next/pages';
import React from 'react';

import { SalaryElement } from '@pflegia/types/api/job-position/salary-element';

import EmojiText from '../emoji-text/EmojiText';

export interface CustomSurgeIncomeElement {
  title: string;
  amount: number;
  amountMax?: number;
}

interface SurgeIncomeProps {
  surgeIncomeElements: (SalaryElement | CustomSurgeIncomeElement)[];
}

export const SurgeIncome: React.FC<SurgeIncomeProps> = ({ surgeIncomeElements }) => {
  const { t } = useTranslation('jobDetails', { keyPrefix: 'salaryDetails' });

  const getSurgeIncomeValue = (element: SalaryElement | CustomSurgeIncomeElement): string => {
    if ('amount' in element) {
      const upperLimit = element.amountMax
        ? ` - €${element.amountMax.toLocaleString('de', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`
        : '';

      const referenceValue = element.amount.toLocaleString('de', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

      const lowerLimit = element.amountMax ? referenceValue : `€${referenceValue}`;

      return `${lowerLimit}${upperLimit} ${t('perMonth')}`;
    }

    return `${element.percent}%${
      element.daysPerMonth
        ? ` - ${element.value.toLocaleString('de', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })} € ${t('perMonth')}`
        : ''
    }`;
  };

  return (
    <div className='my-4 md:my-6'>
      <EmojiText className='text-main-blue text-lg font-medium' emoji='📈'>
        {t('surgeIncome')}
      </EmojiText>
      {surgeIncomeElements.map(surgeIncomeElement => (
        <div className='mt-4 flex' key={surgeIncomeElement.title}>
          <p className='text-default text-sm font-normal'>{surgeIncomeElement.title}</p>
          <p className='text-default ml-auto text-sm'>{getSurgeIncomeValue(surgeIncomeElement)}</p>
        </div>
      ))}
    </div>
  );
};
